/**
 * Global API configuration
 * This is the single source of truth for API URLs across the application
 */

// Get the API URL from environment variables or use default
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api';

// Export other API related constants if needed
export const API_TIMEOUT = 30000; // 30 seconds timeout

// For debugging
if (process.env.NODE_ENV !== 'production') {
  console.log('API Base URL:', API_BASE_URL);
}
